export default {
      id: "ic_like_empty-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_like_empty-usage",
      toString: function () {
        return this.url;
      }
    }